/**
 * Desktop popover dismissal: a press (pointer-down, capture phase) that starts outside every listed
 * element calls `onOutside`. The press still reaches its target — a control under the pointer
 * fires as usual. Shadow roots are honoured through the event's composed path.
 */
export function attachOutsideClick(inside: ReadonlyArray<EventTarget | null | undefined>, onOutside: () => void): () => void {
  const handler = (event: Event): void => {
    const path = event.composedPath();
    for (const target of inside) if (target && path.includes(target)) return;
    onOutside();
  };
  document.addEventListener("pointerdown", handler, true);
  return () => document.removeEventListener("pointerdown", handler, true);
}
